// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface GenderDataTableDTO extends EntitySelectorDTO { 
	id: number;
	abbreviation: string | null;
	name: string | null;
}

const GenderDataTableDTO = {
    className: 'GenderDataTableDTO',
    create: (initValues?: Partial<GenderDataTableDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: 0,
			abbreviation: "",
			name: "",
        },
        initValues);
    },
	id: 'id',
	abbreviation: 'abbreviation',
	name: 'name',
};

export default GenderDataTableDTO;